var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 7.5V9.375V26.25H18.75L28.125 35.625L37.5 26.25H30V9.375V7.5H26.25ZM17.7393 11.25C10.7343 11.25 4.79508 16.4681 3.95508 23.2031C3.82008 23.7844 3.75 24.4287 3.75 25.1074C3.75 39.8187 26.202 53.5303 27.1582 54.104L28.125 54.6899L29.0918 54.104C30.048 53.5265 52.5 39.8187 52.5 25.1074C52.5 24.4699 52.4405 23.8828 52.3242 23.3203C51.4205 16.4316 45.497 11.25 38.5107 11.25C36.842 11.25 35.2575 11.6034 33.75 12.1509V16.2085C35.1938 15.4472 36.8045 15 38.5107 15C43.637 15 47.9844 18.8146 48.6182 23.8696L48.6475 24.0381C48.7187 24.3643 48.75 24.7137 48.75 25.1074C48.75 36.1474 32.325 47.5433 28.125 50.2808C23.9212 47.5508 7.5 36.1662 7.5 25.1074C7.5 24.7099 7.53791 24.35 7.63916 23.855C8.27666 18.8112 12.6205 15 17.7393 15C19.4455 15 21.0562 15.4472 22.5 16.2085V12.1509C20.9925 11.6034 19.408 11.25 17.7393 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI6);
export default __webpack_public_path__ + "static/media/i6.b9ddf23e0b91b09d474d96ac6e09e87c.svg";
export { ForwardRef as ReactComponent };